import { Link } from "react-router-dom";
import { useMe } from "../state";

export function BalanceChip() {
  const { me } = useMe();
  if (!me) return null;
  return (
    <Link
      to="/buy"
      className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-cream-dark text-ink hover:bg-amber/40 transition text-sm"
      title="get more tokens"
    >
      {me.free_credits > 0 && (
        <span className="font-medium">🎟 {me.free_credits} free</span>
      )}
      <span className={me.free_credits > 0 ? "text-ink-soft" : ""}>·</span>
      <span className="font-medium">{me.tokens} tokens</span>
    </Link>
  );
}
